/* import __COLOCATED_TEMPLATE__ from './filter-inputs.hbs'; */
import Component from '@ember/component';
import { service } from '@ember/service';
import { action } from '@ember/object';

import Constants from '../../utils/constants';

export default class FilterInputs extends Component {
    tagName = '';

    @service('data') model;
    @service intl;
    @service componentManager;
    @service errorHandling;
    @service hashDataService;

    panelHeadingBodyArgs = {};
    qaAttrValue = `${Constants.QA_ATTR_PREFIX}_filter_bx`;

    init() {
        super.init();
        this.set('componentManager.filterInputs', this);
    }

    @action openCardTooltip() {
        if (this.openHelp) {
            this.openHelp(`info_modal.filter_input.title`, `info_modal.filter_input.body`, {
                ...this.panelHeadingBodyArgs,
            });
        }
    }

    @action onRextChange() {
        this.hashDataService.setUrlParameter('model.rext');

        if (this.updateAppData) this.updateAppData();
    }

    @action onCextChange() {
        this.hashDataService.setUrlParameter('model.cext');

        if (this.updateAppData) this.updateAppData();
    }

    initialLoadWithHash() {
        this.hashDataService.setUrlParameter('model.rext');
        this.hashDataService.setUrlParameter('model.cext');
    }

    initialLoadWithoutHash() {
        this.hashDataService.setUrlParameter('model.rext');
        this.hashDataService.setUrlParameter('model.cext');
    }
}
